import LocationPackageCreate from './LocationPackageCreate'
import LocationPackageEdit from './LocationPackageEdit'
import { buildPackageList } from 'ui-shared/WrappedInputs/Packages/BasePackageList'

const locationPackageIndex = {
  list: buildPackageList('locations'),
  edit: LocationPackageEdit,
  create: LocationPackageCreate,
}

export default locationPackageIndex
